<template>
  <faq-block v-if="!$apollo.loading" :elements="vragen" vragen header-txt="Veelgestelde vragen"/>
</template>

<script>
import FaqBlock from '~/components/fullwidth-blocks/AccordionBlocks';
import vragen from '~/graphql/queries/vragen';

export default {
  components: {FaqBlock},
  apollo: {
    vragen: {
      query: vragen,
    },
  },
};
</script>
